import { createReducer } from "@reduxjs/toolkit";
import {
  adRewardStatusRequest,
  adRewardStatusSuccess,
  adRewardStatusFailure,
  adRewardClaimRequest,
  adRewardClaimSuccess,
  adRewardClaimFailure,
  adRewardStartPolling,
  adRewardStopPolling,
} from "./adRewardActions";

export type AdRewardState = {
  hasPendingReward: boolean;
  chips: number;
  /** "created" = claimable, "approved" = already claimed, null = never watched */
  rewardState: "created" | "approved" | null;
  cooldownMinutesLeft: number;
  adsWatchedThisHour: number;
  adsRemainingThisHour: number;

  statusLoading: boolean;
  statusError?: string;

  claiming: boolean;
  claimError?: string;

  polling: boolean;
  /** Show "+{chips} chips!" celebration */
  justClaimed: boolean;
};

const initial: AdRewardState = {
  hasPendingReward: false,
  chips: 0,
  rewardState: null,
  cooldownMinutesLeft: 0,
  adsWatchedThisHour: 0,
  adsRemainingThisHour: 10,
  statusLoading: false,
  statusError: undefined,
  claiming: false,
  claimError: undefined,
  polling: false,
  justClaimed: false,
};

export const adRewardReducer = createReducer(initial, (b) => {
  b.addCase(adRewardStatusRequest, (s) => {
    s.statusLoading = true;
    s.statusError = undefined;
  });
  b.addCase(adRewardStatusSuccess, (s, a) => {
    s.statusLoading = false;
    s.hasPendingReward = a.payload.hasPendingReward;
    s.chips = a.payload.chips;
    s.rewardState = a.payload.state;
    s.cooldownMinutesLeft = a.payload.cooldownMinutesLeft;
    s.adsWatchedThisHour = a.payload.adsWatchedThisHour ?? 0;
    s.adsRemainingThisHour = a.payload.adsRemainingThisHour ?? 10;
  });
  b.addCase(adRewardStatusFailure, (s, a) => {
    s.statusLoading = false;
    s.statusError = a.payload;
  });

  b.addCase(adRewardClaimRequest, (s) => {
    s.claiming = true;
    s.claimError = undefined;
    s.justClaimed = false;
  });
  b.addCase(adRewardClaimSuccess, (s) => {
    s.claiming = false;
    s.hasPendingReward = false;
    s.rewardState = "approved";
    s.justClaimed = true;
    // cooldown will be refreshed by the follow-up status call
  });
  b.addCase(adRewardClaimFailure, (s, a) => {
    s.claiming = false;
    s.claimError = a.payload;
  });

  b.addCase(adRewardStartPolling, (s) => {
    s.polling = true;
  });
  b.addCase(adRewardStopPolling, (s) => {
    s.polling = false;
  });
});


